import React, { useContext, useState } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/stock/createSaleProductValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { SaleProductContext } from "../SaleProduct";
import { UserContext } from "../../../../App";

axios.defaults.baseURL = API;

function CreateSaleProduct(props) {
    function getDate() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return `${year}-${month}-${date} ${time}`;
    }
    const {SubTotal, setSubTotal, showData, setShowData, PaymentTypeList} = useContext(SaleProductContext);
    const {userID, LocationID} = useContext(UserContext);

    const handleSelectPaymentType = (e) => {
        var data = PaymentTypeList.filter(function (item) {
            return item.PaymentType == e.target.value
        })
        if (data.length > 0) {
            handleChange("PaymentType", data[0].PaymentType);
            handleChange("PaymentTypeID", data[0].PaymentTypeID);
        } else {
            handleChange("PaymentType", "");
            handleChange("PaymentTypeID", "");
        }
    };

    async function saveTutorial() {
        
        let token = localStorage.getItem("token");
        var data = {
            PaymentTypeID: values.PaymentTypeID,
            SubTotal: SubTotal,
            CreatedDate: getDate(),
            CreatedByID: userID,
            StatusID: 1,
        }
        await axios.post("/CreateSaleProduct", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            CreateSaleProductOrderDetail(response?.data?.insertId);
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    async function CreateSaleProductOrderDetail(SaleProductID) {
        let token = localStorage.getItem("token");
        if(showData.length > 0) {
            for (var i=0; i < showData.length; i++) {
                var list;
                list ={
                    SaleProductID: SaleProductID,
                    ProductID: showData[i].ProductID,
                    Quantity: showData[i].Quantity,
                    BuyPrice: showData[i].BuyPrice,
                };
                await axios.post("/CreateSaleProductDetail", list, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                    getInventory(showData[i].ProductID, showData[i].Quantity);
                }).catch((err) => {
                    console.log(err);
                });
            } 
            ClearData();
            props.onClick(false);
        }
    }

    async function getInventory(ProductID, Quantity) {
        await axios.get(`/getInventory/${ProductID}`).then((response) => {
            let Data = response?.data;
            if(Data.length > 0){
                var qty = Number(Data[0].Quantity) - Number(Quantity);
                UpdateInventory(Data[0].InventoryID, qty);
            }
        })
            .catch((error) => {
            console.log(error);
        });
      }
    
      async function UpdateInventory(InventoryID, qty) {
        let token = localStorage.getItem("token");
        var data = {
            Quantity: qty
        }
        await axios.put(`/updateInventory/${InventoryID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            // props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    }

    const ClearData = () => {
        localStorage.removeItem('saleProductOrderData');
        handleChange("PaymentType", "");
        handleChange("PaymentTypeID", "");
        setSubTotal(0);
        setShowData([]);
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="content">
                <div className="Header">
                    <span>ສ້າງບິນຂາຍເຄື່ອງ</span>
                </div>
                <div className="Body">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="row">
                            <div className="col form-group">
                                <label>ປະເພດຈ່າຍ: </label>
                                <select name="PaymentTypeID" onChange={(e) => handleSelectPaymentType(e)}
                                    className={`input form-control ${errors.PaymentTypeID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກໝວດສິນຄ້າ'}
                                    </option>
                                    {   PaymentTypeList && PaymentTypeList.map(item => (
                                        <option
                                            key={item.PaymentTypeID}
                                            value={item.PaymentType}
                                        >
                                            {item.PaymentType}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="footer">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateSaleProduct;
